module.exports = __webpack_public_path__ + "img/logo_cna_circulo.30c72b34.png";